import { useNavigate as useReactNavigate } from "react-router-dom";

/**
 * A wrapper for React Router's useNavigate hook.
 * This allows us to maintain compatibility with code that uses history
 * while gradually migrating to useNavigate.
 */
export const useNavigate = () => {
  const navigate = useReactNavigate();
  
  // Create a history-like object that uses navigate internally
  const history = {
    push: (path: string) => navigate(path),
    replace: (path: string) => navigate(path, { replace: true }),
    goBack: () => navigate(-1),
    go: (delta: number) => navigate(delta),
  };
  
  return history;
};

// For backward compatibility with useHistory
export const useHistory = useNavigate;